<template>
  <div class="detail-page">
    <AppNavbar
      class="nav-bar"
      :title="title"
      :options="options"
      :zIndex="10"
      :placeholder="true"
    >
      <div slot="right" @click="bindShare">
        <span class="share iconfont icon-share"></span>
      </div>
    </AppNavbar>
    <div v-if="detailData">
      <div class="detail-content show-padding">
        <div class="top">
          <div class="title">{{ detailData.title }}</div>
          <div class="desc">{{ detailData.sub_title }}</div>
        </div>
        <!-- 菜单 -->
        <div class="compare-canvas" v-show="!isShareing">
          <div class="user-info">
            <div class="user-top">
              <img
                class="avatar"
                @click.stop="jumpUserInfo"
                :src="detailData.user_head"
              />
              <div class="user-info-right">
                <div class="user-name">
                  <span>{{ detailData.truename || '' }}</span>
                  <span class="clock-num"
                    >打卡<span class="text"
                      ><span class="num">{{
                        detailData.click_data.realityClickNum
                      }}</span
                      ><span>次</span></span
                    ></span
                  >
                </div>
                <div class="camp">
                  <span>{{ detailData.product_alias_name || '' }}学员</span>
                  <span class="line"> ｜ </span>
                  <span>{{ (coachInfo && coachInfo.name) || '' }}</span>
                </div>
              </div>
            </div>
            <div class="tag-list">
              <span
                class="tag-item"
                v-for="(item, index) in detailData.label_data"
                :key="index"
                >{{ item }}</span
              >
            </div>
          </div>
          <div class="compare-title">
            <div class="text"
              >身体数据变化<span class="unit"
                >（单位：{{ canvasData[curType].unit }}）</span
              ></div
            >
            <div class="type-list">
              <div
                class="type-item"
                :class="{ 'type-item-active': curType == index }"
                v-for="(item, index) in typeList"
                :key="index"
                @click.stop="changeType(index)"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <div class="echart-content">
            <div class="echart-canvas">
              <van-swipe
                ref="weightWaist"
                class="echart-swiper"
                :autoplay="200000"
                indicator-color="white"
                :loop="false"
                :show-indicators="false"
                @change="changeSwiper"
                :touchable="false"
              >
                <van-swipe-item v-for="(item, index) in typeList" :key="index">
                  <div v-show="canvasData.length">
                    <div class="compare-weight">
                      <div class="item">
                        <div class="item-title">
                          初始{{ canvasData[index].name }}
                        </div>
                        <div class="item-text">
                          {{ canvasData[index].startData }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="item-title">
                          当前{{ canvasData[index].name }}
                        </div>
                        <div class="item-text">
                          {{ canvasData[index].curData }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="item-title">变化</div>
                        <div class="item-text blue">
                          {{ canvasData[index].changeData
                          }}<span
                            class="iconfont icon-xingzhuangjiehebeifen"
                            :class="{
                              up: canvasData[index].changeData > 0,
                              down: canvasData[index].changeData <= 0
                            }"
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="mychart-content"
                    v-show="canvasData[index].xList.length"
                  >
                    <div
                      class="my-chart"
                      :id="'mychart-dom-line-' + index"
                    ></div>
                  </div>
                  <img
                    class="no-img"
                    v-if="!canvasData[index].xList.length"
                    src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e3ac4c595c1a08370e4ac3cc02c92389.png"
                  />
                </van-swipe-item>
              </van-swipe>
            </div>
          </div>
        </div>
        <!-- 营养师信息 -->
        <div class="n-info" v-if="coachInfo" @click.stop="bindJumpCoachInfo">
          <div class="c-top">
            <img class="avatar" :src="coachInfo.bust || ''" alt="" />
            <div class="name">
              <div class="c-name">高级营养师</div>
              <div class="nickname">{{ coachInfo.name }}</div>
            </div>
            <div class="iconfont icon-you"></div>
          </div>
          <div class="desc">
            擅长领域：{{ coachInfo.expertise | filterExpertise }}
          </div>
          <div class="bottom">
            <div class="b-item">
              <div class="b-title">评分</div>
              <div class="star-content"
                ><span
                  class="star iconfont icon-shixinxingxing"
                  v-for="(item, index) in 5"
                  :key="index"
                ></span
              ></div>
            </div>
            <div class="b-item">
              <div class="b-title">服务人数</div>
              <div class="num">{{ coachInfo.members }}</div>
            </div>
            <div class="b-item">
              <div class="b-title">帮助减重（KG）</div>
              <div class="num">{{ coachInfo.weights }}</div>
            </div>
          </div>
        </div>
        <!-- 蜕变过程 -->
        <div class="wapper">
          <div class="nav-list">
            <div
              class="nav-item"
              :class="{
                'nav-item-active': item.index == curNav,
                'nav-item-before': item.index == curNav - 1,
                'nav-item-after': item.index == curNav + 1
              }"
              v-for="(item, index) in navList"
              :key="index"
              @click="bindNavChange(item.index)"
            >
              {{ item.text }}
              <div
                class="nav-flag"
                v-show="item.highlight && curNav != item.index"
              >
                跟Ta吃一起瘦!
              </div>
            </div>
          </div>
          <!-- 减肥故事 -->
          <div class="wapper-2 case-image-content" v-show="curNav == 0">
            <img
              class="case-image"
              v-for="(caseitem, caseindex) in detailData.thin_story_img"
              :key="caseindex"
              :src="caseitem.url"
              alt=""
            />
          </div>
          <div class="wapper-1" v-if="curNav == 1">
            <div class="wapper-padding">
              <div
                class="life-container"
                v-if="
                  detailData.end_life_img.length ||
                  detailData.start_life_img.length
                "
              >
                <div class="compare-swiper-content">
                  <van-swipe
                    class="my-swipe"
                    :autoplay="200000"
                    indicator-color="white"
                    :loop="false"
                    :show-indicators="false"
                    @change="bindPictureChange"
                  >
                    <van-swipe-item
                      class="compare-swiper-item"
                      v-for="(item, index) in detailData.end_life_img.length >
                      detailData.start_life_img.length
                        ? detailData.end_life_img
                        : detailData.start_life_img"
                      :key="index"
                    >
                      <div class="image-content">
                        <div
                          class="image-item before"
                          v-if="detailData.start_life_img[index]"
                        >
                          <div class="flag">入营前</div>
                          <div class="time">
                            {{ detailData.s_date | filterCampTime }}
                          </div>
                          <div class="compare-image-content">
                            <img
                              @click.stop="
                                previewLiveImage(
                                  detailData.start_life_img[index]
                                )
                              "
                              class="compare-image"
                              :src="detailData.start_life_img[index]"
                            />
                          </div>
                        </div>
                        <div
                          class="image-item after"
                          v-if="detailData.end_life_img[index]"
                        >
                          <div class="flag">结营后</div>
                          <div class="time">
                            {{ detailData.e_date | filterCampTime }}
                          </div>
                          <div class="compare-image-content">
                            <img
                              class="compare-image"
                              @click.stop="
                                previewLiveImage(detailData.end_life_img[index])
                              "
                              :src="detailData.end_life_img[index]"
                            />
                          </div>
                        </div>
                      </div>
                    </van-swipe-item>
                  </van-swipe>
                </div>
                <div class="swiper-indicator">
                  <span
                    class="swiper-indicator-item"
                    :class="{
                      'swiper-indicator-item-active': curSwiper == index
                    }"
                    v-for="(item, index) in detailData.end_life_img.length >
                    detailData.start_life_img.length
                      ? detailData.end_life_img
                      : detailData.start_life_img"
                    :key="index"
                  ></span>
                </div>
              </div>
              <!-- 对比照 -->
              <div
                class="compare-container"
                v-if="detailData.compareImage.length"
              >
                <div
                  class="list"
                  v-for="(typeitem, typeindex) in detailData.compareImage"
                  :key="typeindex"
                >
                  <div
                    class="item"
                    v-for="(compareitem, compareindex) in typeitem"
                    :key="compareindex"
                  >
                    <img
                      class="image"
                      :src="compareitem.url"
                      alt=""
                      @click.stop="previewCompareImage(compareitem.url)"
                    />
                    <div class="text">{{ compareitem.name }}</div>
                  </div>
                  <div
                    class="icon iconfont icon-web__bitebiyoujiantou"
                    v-if="typeitem.length > 1"
                  ></div>
                </div>
              </div>
              <!-- -->
              <div class="say-container">
                <div class="say-top">
                  <img
                    class="quotation-marks"
                    src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0cd203adf0c37cafa5173e417a7a2cbc.png"
                    alt=""
                  />
                  <div class="center">
                    <div class="nickname">{{ detailData.truename }}</div>
                    <div class="class">
                      {{ detailData.product_alias_name || '' }}
                    </div>
                  </div>
                  <img class="user-avatar" :src="detailData.user_head" alt="" />
                </div>
                <div class="say-list">
                  <div
                    class="say-item"
                    v-for="(item, index) in detailData.my_story"
                    :key="index"
                    v-html="item.answer"
                  >
                  </div>
                </div>
              </div>
            </div>
            <!-- 营期足迹 -->
            <div class="camp-screenshot">
              <div class="wapper-padding">
                <div class="screenshot-top">
                  <div class="title">营期足迹</div>
                  <img
                    class="q-a"
                    src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ff23e7235f8fc084bd45ae2bdd229597.png"
                    alt=""
                  />
                </div>
                <div class="desc">
                  在减脂期间有任何问题，都可以直接在群内咨询我的营养师，她都会耐心为我分析解答
                </div>
              </div>
              <van-swipe
                v-if="detailData.camp_footprint.length"
                class="screenshot-swipe"
                :autoplay="200000"
                :loop="false"
                :show-indicators="false"
                @change="bindScreenshotChange"
              >
                <van-swipe-item
                  class="screenshot-item"
                  v-for="(
                    screenshotitem, screenshotindex
                  ) in detailData.camp_footprint"
                  :key="screenshotindex"
                  @click.stop="
                    previewScreenshotImage(
                      detailData.camp_footprint,
                      screenshotindex
                    )
                  "
                >
                  <img
                    class="screenshot-image"
                    :src="screenshotitem.url"
                    alt=""
                  />
                </van-swipe-item>
              </van-swipe>
              <div class="swiper-indicator">
                <span
                  class="swiper-indicator-item"
                  :class="{
                    'swiper-indicator-item-active': curScreenshot == index
                  }"
                  v-for="(item, index) in detailData.camp_footprint.length"
                  :key="index"
                ></span>
              </div>
            </div>
          </div>
          <!-- 饮食记录 -->
          <div class="wapper-2" v-show="curNav == 2">
            <!-- <div class="desc">
              营养师一对一的饮食点评指导，让我每一餐都可以学到新的减脂营养知识，让我越吃越好，越吃越瘦！
            </div> -->
            <div class="clock-info">
              <div class="clock-item">
                <div class="item-text">打卡天数</div>
                <div class="item-num">{{ detailData.click_data.clickDay }}</div>
              </div>
              <div class="clock-item">
                <div class="item-text">打卡次数</div>
                <div class="item-num">{{
                  detailData.click_data.realityClickNum
                }}</div>
              </div>
              <div class="clock-item">
                <div class="item-text">打卡效率</div>
                <div class="item-num">{{
                  detailData.click_data.clickRate | filterRate
                }}</div>
              </div>
            </div>
            <div class="diet-container">
              <div class="type-list diet-nav">
                <div
                  class="type-item"
                  :class="{ 'type-item-active': curDiet == index }"
                  v-for="(item, index) in dietTypeList"
                  :key="index"
                  @click="bindChangeDiet(index)"
                >
                  {{ item.text }}
                </div>
              </div>
              <div
                class="day-content"
                v-for="(item, index) in dietData[curDiet].list"
                :key="index"
              >
                <div class="day-top">
                  <span class="day">{{ item.day | filterDay }}</span>
                  <!--  <span class="time">{{ item.day }}</span> -->
                </div>
                <div class="day-list">
                  <div
                    class="diet-item"
                    v-for="(item1, index1) in item.data"
                    :key="index1"
                  >
                    <div class="diet-left">
                      <div class="left-dot"></div>
                      <div class="left-line"></div>
                    </div>
                    <div class="diet-right">
                      <div class="right-top">
                        <span class="type">{{ item1.meal_name }}</span
                        ><span class="pub-time">{{
                          item1.addtime | filterAddTime
                        }}</span>
                      </div>
                      <div class="user-text">
                        {{ item1.say }}
                      </div>
                      <div class="diet-image-list">
                        <img
                          class="diet-image"
                          :class="{ 'diet-image-1': item1.content.length <= 1 }"
                          v-lazy="imageitem"
                          v-for="(imageitem, imageindex) in item1.content"
                          v-show="imageindex < 4"
                          :key="imageindex"
                          @click="previewDietImage(imageitem, item1.content)"
                        />
                        <div class="image-num" v-if="item1.content.length > 4">
                          +{{ item1.content.length - 4 }}
                        </div>
                      </div>
                      <div class="score" v-if="item1.p_star">
                        <div class="num">{{ item1.p_star }}星</div>
                        <div class="star-list">
                          <span
                            class="star iconfont icon-shixinxingxing"
                            :class="{ 'star-active': starindex < item1.p_star }"
                            v-for="(staritem, starindex) in 5"
                            :key="starindex"
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 没有餐卡 -->
              <div
                class="not-diet"
                v-if="
                  dietData[curDiet].loaded && !dietData[curDiet].list.length
                "
              >
                暂无饮食记录
              </div>
            </div>
          </div>
        </div>
        <!-- 相似案例 -->
        <div class="similar-case" v-if="caseList.length">
          <div class="title">相似的案例</div>
          <div class="case-list">
            <div
              class="case-item"
              v-for="(item, index) in caseList"
              :key="index"
              @click="bindClickCase(item)"
            >
              <img
                class="avatar"
                :src="
                  (item.user_name && item.user_name.head_img) || defaultCoach
                "
                alt=""
              />
              <div class="item-right">
                <div class="nickname">
                  {{ (item.user_name && item.user_name.truename) || '' }}
                </div>
                <div class="desc">
                  {{ item.product_name }} ｜{{ item.label_name }}
                </div>
              </div>
              <div class="iconfont icon-you"></div>
            </div>
          </div>
        </div>
        <div class="footer-content" v-if="userState == 2 || userState == 0">
          <div class="footer-top">
            <img
              class="avatar"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c821a82aec3fd5caeb90a7995579fa3b.jpg"
              alt=""
            />
            <div class="center">
              <div class="name">营养师李玲</div>
              <div class="desc">国家注册营养师</div>
            </div>
            <div class="btn-content" @click="bindConsultUs">
              <div class="free">首次免费</div>
              <span class="iconfont icon-comments-fill-8"></span
              ><span>咨询她</span>
            </div>
          </div>
          <div class="footer-bottom">
            <span class="gray">擅长领域：</span>
            <span>大基数、小基数、产后减脂、学生、上班族</span>
          </div>
        </div>
        <div class="footer-content" v-if="userState == 1">
          <div class="footer-top">
            <img
              class="avatar"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/dfa22e8317cca151b1229e46f2bbdf2d.jpg"
              alt=""
            />
            <div class="center">
              <div class="name">陪伴官杨涵</div>
              <div class="desc">私人减脂规划师,帮您保持易瘦体质</div>
            </div>
            <div class="btn-content" @click="bindConsultUs">
              <span class="iconfont icon-comments-fill-8"></span
              ><span>免费咨询</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-loading
      class="v-loading"
      v-else
      text-color="#888888"
      color="#888888"
      vertical
      >加载中...</van-loading
    >
    <!-- 分享组件 -->
    <van-overlay :show="showShare" @click="showShare = false" z-index="11">
      <ShareComponent
        v-if="showShare"
        class="share-container"
        @close="bindCloseShare"
        @link="bindClickLink"
        @image="bindClickImage"
        :copyUrl="qrcodeUrl"
      />
    </van-overlay>
    <PosterComponent
      v-if="showPoster"
      @close="bindClosePoster"
      el="result"
      @error="bindPosterError"
      @success="bindPosterSuccess"
    ></PosterComponent>
    <PosterPage
      :coachInfo="coachInfo"
      :detailData="detailData"
      :bodyData="canvasData"
    ></PosterPage>
  </div>
</template>
<script>
import ShareComponent from '../../useBoth/ingredient-list/components/share.vue'
import PosterComponent from '../../useBoth/ingredient-list/components/poster.vue'
import PosterPage from './components/poster-page.vue'
import { options as canvasOptions } from './data'
import ChatContent from '@/views/business-center/components/chat-content/index'
import CommentContent from '@/views/business-center/components/comment-content/index'
import { ImagePreview } from 'vant'
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core'
// 引入柱状图图表，图表后缀都为 Chart
import { LineChart } from 'echarts/charts'
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DataZoomComponent
} from 'echarts/components'
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features'
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers'
import AppNavbar from '@/components/app/nav-bar/index.vue'
// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  DataZoomComponent,
  LineChart
])
export default {
  name: 'case-detail',
  components: {
    ChatContent,
    CommentContent,
    AppNavbar,
    ShareComponent,
    PosterComponent,
    PosterPage
  },
  data() {
    return {
      showShare: false,
      qrcodeUrl: '',
      showPoster: false,
      weekCase: [
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6423916716cb342ac0ad716ebf4e0c14.jpg',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0542c5fad86f015201b2e18185e48ecd.jpg',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5e26d68d9d3e4349517ac8a5828267a1.jpg'
      ],
      title: '减脂日记',
      options: {
        barBackgroundColor: 'transparent',
        fontSize: '4.8vw'
      },
      defaultCoach: '',
      navList: [
        {
          index: 1,
          text: '蜕变过程'
        },
        {
          index: 2,
          text: '饮食记录',
          highlight: true
        }
      ],
      curNav: 1,
      curDiet: 0,
      curSwiper: 0,
      curScreenshot: 0, //当前截图轮播图index
      typeId: '',
      canvasData: [],
      ecLine: {
        /* canvas图表数据 */
        lazyLoad: true
      },
      typeList: ['体重', '腰围'],
      dietTypeList: [
        {
          id: 'desc',
          text: '最近'
        },
        {
          id: 'asc',
          text: '最早'
        }
      ],
      curType: 0,
      detailData: null,
      coachInfo: null,
      dietData: [
        {
          list: [],
          loading: false,
          loaded: false,
          finished: false
        },
        {
          list: [],
          loading: false,
          loaded: false,
          finished: false
        }
      ],
      loadDiet: false,
      dietPage: 1,
      finished: false,
      loading: false,
      data: null,
      id: '',
      readyNum: 0, //canvas数据和dom准备的数量 必须都拿到才能渲染canvas
      isShareing: false, //是否正在分享中
      echartsDoms: [],
      userState: -1, //用户状态 1表示老会员 0和2其他表示新会员或者过期会员
      caseList: [], //相似案例
      pathUrl: ''
    }
  },
  watch: {
    $route(to) {
      if (to.name === 'case-detail') {
        this.init() // 一般是执行你写在 mounted 下的方法
      }
    }
  },
  filters: {
    filterDay(str) {
      return str.replace(/-/g, '.')
    },
    filterRate(rate) {
      return parseFloat((rate * 100).toFixed(2)) + '%'
    },
    filterExpertise(arr) {
      if (Array.isArray(arr)) {
        return arr.join(' / ')
      }
      return '无'
    },
    formatDynamicNumber(num) {
      if (!num && num !== 0) {
        return ''
      }
      var res = ''
      num = isNaN(parseInt(num)) ? '-' : parseInt(num)
      if (num === '-') {
        return '-'
      }
      if (num >= 100000) {
        res = '10w+'
      } else if (num >= 10000) {
        res = (num / 10000).toFixed(1) + 'w'
      } else if (num >= 1000) {
        res = (num / 1000).toFixed(1) + 'k'
      } else {
        res = num
      }
      return res
    },
    filterCampTime(str) {
      return str.replace(/-/g, '.')
    },
    filterAddTime(time) {
      if (!time) {
        return ''
      }
      let arr = time.split(' ')
      return (Array.isArray(arr) && arr[1]) || ''
    }
  },
  created() {},
  mounted() {
    this.init()
    //案例库详情埋点
    this.$http.bindUMA('BG_ANLI_XQ', { caseid: this.id })
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.bindScroll)
  },
  methods: {
    //跳转营养师信息页
    bindJumpCoachInfo() {
      console.log(this.detailData.coach_id)
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(
          '/dietitianDetails?id=' + this.detailData.coach_id
        )
      }
    },
    init() {
      //初始化全部data数据
      Object.assign(this.$data, this.$options.data())
      this.getParams(this.$route.query)
      this.getMemberInfo()
      this.loadData()
      this.readyCanvasData()
      document.addEventListener('scroll', this.bindScroll)
    },
    getCoachInfo(coachId) {
      let params = {
        id: coachId
      }
      this.$http
        .getBaseApp('member/expert/dietitianInfo', params)
        .then((res) => {
          res = res.data
          if (res.data && !Array.isArray(res.data)) {
            this.coachInfo = res.data
          }
        })
    },
    bindCloseShare() {
      this.showShare = false
    },
    bindShare() {
      this.showShare = true
    },
    bindClickImage(index) {
      switch (index) {
        case 0:
          this.saveImage()
          break
        case 1:
          this.shareImageToWechatFriend()
          break
        case 2:
          this.shareImageToWechat()
          break
      }
      this.showShare = false
    },
    //分享点击链接
    bindClickLink(index) {
      switch (index) {
        case 0:
          this.createPoster()
          break
        case 1:
          this.shareWechatFriend()
          break
        case 2:
          this.shareWechat()
          break
      }
      this.showShare = false
    },
    createPoster() {
      this.showPoster = true
    },
    bindClosePoster() {
      this.showPoster = false
    },
    bindPosterError() {},
    bindPosterSuccess() {},
    bindScroll(e) {
      let scrollTop = e.target.documentElement.scrollTop
      if (scrollTop <= 10) {
        this.options = {
          barBackgroundColor: 'transparent',
          fontSize: '4.8vw'
        }
      } else {
        this.options = {
          barBackgroundColor: '#fff',
          fontSize: '4.8vw'
        }
      }
    },
    bindNavChange(index) {
      this.curNav = index
      if (index == 2 && !this.dietData[this.curDiet].list.length) {
        this.getDietData()
      }
    },
    bindChangeDiet(index) {
      this.curDiet = index
      this.getDietData()
    },
    bindClickCase(item) {
      this.$router.push({
        path: '/case-detail',
        query: {
          id: item.case_id
        }
      })
    },
    //获取相似案例
    getSimilarCase() {
      let params = {
        caseId: this.id
      }
      this.$http
        .getApp('member/AppCamp/getAlikeCase', params)
        .then((res) => {
          res = res.data
          this.caseList = res.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getDietData() {
      let curDiet = this.curDiet
      if (
        this.dietData[curDiet].finished ||
        this.dietData[curDiet].loading ||
        this.dietData[curDiet].loaded
      ) {
        return
      }
      this.dietData[curDiet].loading = true
      let params = {
        pid: this.detailData.product_id,
        uid: this.detailData.unify_id,
        field: 'addtime',
        sort: this.dietTypeList[curDiet].id
      }
      this.$http
        .getApp('member/AppCamp/getGroupRecord', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.dietData[curDiet].loaded = true
            if (res.data.length) {
              this.dietData[curDiet].list = res.data
            } else {
              this.dietData[curDiet].finished = true
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.dietData[curDiet].loading = true
        })
    },
    getMemberInfo() {
      this.$http
        .getBaseApp('member/ActivitySys/judgeUser', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.userState = res.data.state
            if (this.userState == 1) {
              this.$http.bindUMA('BG_ALXQ_ZX', { caseid: this.id })
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getParams(options) {
      this.id = +(options && options.id) || ''
    },
    bindConsultUs() {
      if (this.$http._isApp()) {
        this.userState == 1 &&
          this.$http.bindUMA('CLICK_ALXQ_ZX', { caseid: this.id })
        //1表示老用户
        let path =
          'pages/image-page/index?url= https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2F167b2b96fd56535cce063d39b7aac93c.jpg&type=11'
        this.$betterwe.onAppPageRoute({
          path: 'miniProgram', //跳转页面路径
          //跳转所需参数
          params: [
            { key: 'userName', value: 'gh_0d804ee2c21b' }, //原始id
            { key: 'path', value: path }
          ]
        })
      }
    },
    //预览生活照
    previewLiveImage(curUrl) {
      let urls = []
      let info = this.detailData
      //获取较长的那个对比生活照片数组
      let longArr =
        info.start_life_img.length > info.end_life_img.length
          ? info.start_life_img
          : info.end_life_img
      longArr.map((item, index) => {
        if (info.start_life_img[index]) {
          urls.push(info.start_life_img[index])
        }
        if (info.end_life_img[index]) {
          urls.push(info.end_life_img[index])
        }
      })
      let index = urls.indexOf(curUrl)
      ImagePreview({
        images: urls,
        startPosition: index
      })
    },
    //预览截图
    previewScreenshotImage(item, index) {
      let images = item.map((item) => {
        return item.url
      })
      ImagePreview({
        images: images,
        startPosition: index
      })
    },
    //预览餐卡图片
    previewDietImage(cur, urls) {
      ImagePreview({
        images: urls,
        startPosition: urls.indexOf(cur)
      })
    },
    //预览对比照
    previewCompareImage(curUrl) {
      let urls = []
      let info = this.detailData
      //获取较长的那个对比照数组
      let longArr =
        info.start_img.length > info.end_img.length
          ? info.start_img
          : info.end_img
      longArr.map((item, index) => {
        if (info.start_img[index]) {
          urls.push(info.start_img[index])
        }
        if (info.end_img[index]) {
          urls.push(info.end_img[index])
        }
      })
      console.log(urls)
      let index = urls.indexOf(curUrl)
      ImagePreview({
        images: urls,
        startPosition: index
      })
    },
    bindPictureChange(index) {
      this.curSwiper = index
    },
    bindScreenshotChange(index) {
      this.curScreenshot = index
    },

    jumpUserInfo() {
      let id = this.data.detailData.unify_id
      return
      if (this.$http._isApp()) {
        let obj = {
          path: '/',
          params: [
            {
              key: 'id',
              value: id
            }
          ]
        }
        this.$betterwe.onAppPageRoute(obj)
      }
    },
    setOption(chart, xList, yList) {
      let showNum = 7 //echats图表显示的数据
      let startValue = yList.length - showNum >= 0 ? yList.length - showNum : 0
      let endValue = yList.length - 1 >= 0 ? yList.length - 1 : 0
      var options = canvasOptions
      options.dataZoom[0].startValue = startValue
      options.dataZoom[0].endValue = endValue
      options.xAxis.data = xList
      //设置最后一个时间圆点设置红色
      if (yList.length) {
        yList[yList.length - 1] = {
          value: yList[yList.length - 1],
          itemStyle: {
            color: '#F04646', //点的颜色
            borderWidth: 3
          },
          label: {
            show: true,
            color: '#F04646',
            position: 'top',
            fontSize: 10
          }
        }
      }
      options.series[0].data = yList
      chart.setOption(options)
      // chart.on('click', function (params) {
      //   console.log('paramsparams', params, WX)
      //   WX.setData({
      //     showDel: true,
      //     delTop: (params.event.offsetY - 60),
      //     delLeft: (params.event.offsetX - 20)
      //   })
      // });
    },
    changeType(index) {
      this.curType = index
      this.$refs.weightWaist.swipeTo(index)
    },
    changeSwiper(index) {
      this.curType = index
    },
    /**
     * 加载echarts
     */
    initEcharts: function (index) {
      // 接下来的使用就跟之前一样，初始化图表，设置配置项
      let div = document.getElementById('mychart-dom-line-' + index)
      this.echartsDoms[index] = echarts.init(div)
      this.setOption(
        this.echartsDoms[index],
        this.canvasData[index].xList,
        this.canvasData[index].yList
      )
    },
    loadData() {
      let params = {
        id: this.id
      }
      this.$http
        .postApp('member/AppCamp/caseDetail', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.getSimilarCase()
            res.data = this.dealData(res.data)
            let canvasData = this.dealCanvasData(res.data.change)
            this.detailData = res.data
            this.canvasData = canvasData
            if (res.data.coach_id) {
              this.getCoachInfo(res.data.coach_id)
            }
            if (res.data.thin_story_img && res.data.thin_story_img.length) {
              this.navList.unshift({
                index: 0,
                text: '瘦身故事'
              })
              this.curNav = 0
            }
            this.$nextTick(() => {
              this.readyCanvasData()
            })
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    readyCanvasData() {
      this.readyNum++
      if (this.readyNum >= 2) {
        // 获取组件
        for (let i = 0; i < this.typeList.length; i++) {
          this.initEcharts(i)
        }
      }
    },
    dealCanvasData(data) {
      let arr = []
      arr.push({
        changeData: parseFloat(
          (data.end_weight - data.first_weight).toFixed(2)
        ),
        startData: data.first_weight,
        curData: data.end_weight,
        xList: data.weight_list.map((item) => {
          let time = item.key.split(' ')[0]
          return time.slice(5).replace('-', '/')
        }),
        yList: data.weight_list.map((item) => {
          return +item.val
        }),
        name: '体重',
        unit: 'kg'
      })
      arr.push({
        changeData: parseFloat((data.end_waist - data.first_waist).toFixed(2)),
        startData: data.first_waist,
        curData: data.end_waist,
        xList: data.waist_list.map((item) => {
          let time = item.key.split(' ')[0]
          return time.slice(5).replace('-', '/')
        }),
        yList: data.waist_list.map((item) => {
          return +item.val
        }),
        name: '腰围',
        unit: 'cm'
      })
      return arr
    },
    //处理数据
    dealData(data) {
      //处理对比照，如果入营和结营的第几张图片都没有则删除这个位置的空字符串
      let end_img = []
      let start_img = []
      for (var i in data.start_img) {
        start_img.push(data.start_img[i])
      }
      for (var i in data.end_img) {
        end_img.push(data.end_img[i])
      }
      let type = ['正面图', '背面图', '侧面图']
      let compareImage = []
      let compareLenArr =
        start_img.length > end_img.length ? start_img : end_img
      compareLenArr.map((item, index) => {
        if (!start_img[index] && !end_img[index]) {
          return
        }
        let arr = []
        if (start_img[index]) {
          arr.push({
            name: (type[index] || '') + '(入营前)',
            url: start_img[index]
          })
        }
        if (end_img[index]) {
          arr.push({
            name: (type[index] || '') + '(结营后)',
            url: end_img[index]
          })
        }
        compareImage.push(arr)
      })
      let myStoryImage = []

      if (Array.isArray(data.my_story)) {
        data.my_story.map((item) => {
          if (item.img) {
            item.img.map((item1) => {
              if (item1.url) {
                myStoryImage.push(item1.url)
              }
            })
          }
        })
      }
      data.answering_questions_img =
        data.answering_questions_img.concat(myStoryImage)
      data.compareImage = compareImage
      data.start_img = start_img
      data.end_img = end_img
      data.dietData = []
      if (
        data.dietary_changes_low_data &&
        !Array.isArray(data.dietary_changes_low_data)
      ) {
        data.dietData.push(data.dietary_changes_low_data)
      }
      if (
        data.dietary_changes_high_data &&
        !Array.isArray(data.dietary_changes_high_data)
      ) {
        data.dietData.push(data.dietary_changes_high_data)
      }
      return data
    },
    /**
     * 生命周期函数--监听页面显示
     */
    onShow: function () {
      this.setData({
        isShareing: false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.detail-page {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: #f9f9f9;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/033c7c68eecddee0dc9dcf1c876ecc34.png');
  background-repeat: no-repeat;
  background-position: center top;
}
.nav-bar {
  .share {
    padding: 10px;
  }
}
.detail-content {
  overflow: hidden;
  padding: 0px 20px;
  box-sizing: border-box;
}
.show-padding {
  box-sizing: border-box;
  padding-bottom: 110px;
}
.top {
  margin-top: 30px;
  margin-bottom: 16px;
  .title {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 25px;
    margin-bottom: 4px;
  }
  .desc {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;
  }
}

.article-info {
  padding-bottom: 15px;
  border-bottom: 1px solid #f1f1f1;
}

.article-info .title {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 30px;
  margin-bottom: 10px;
}

.article-info .review {
  margin-bottom: 7px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.5);
  line-height: 17px;
  display: flex;
  align-items: center;
}

.info-bottom {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.5);
  line-height: 20px;
}

.info-bottom .keyword-title {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.5);
  line-height: 17px;
}

.info-bottom .keyword {
  font-weight: 600;
  color: #2882e9;
  margin-right: 9px;
}

.article-info .review .line {
  margin: 0px 15px;
  height: 10px;
  border-right: 1px solid #979797;
}

.info-bottom .public-image {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.info-bottom .line {
  margin: 0px 15px;
  height: 10px;
  border-right: 1px solid #979797;
}

.info-bottom .public-image:last-child {
  margin-right: 0px;
}

.user-info {
  padding-bottom: 17px;
  border-bottom: 1px dashed #d5d5d5;
  margin-bottom: 16px;
}
.user-top {
  display: flex;
  align-items: flex-start;
}
.user-info .avatar {
  flex: 0 0 36px;
  margin-right: 10px;
  width: 36px;
  height: 36px;
  background-color: #d8d8d8;
  border-radius: 12px;
  overflow: hidden;
  object-fit: cover;
}

.user-info .user-name {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
  line-height: 22px;
  height: 22px;
  margin-bottom: 3px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-right: 14px;
  display: flex;
  align-items: center;
  .clock-num {
    margin-left: 10px;
    height: 15px;
    background: #6236ff;
    border-radius: 4px;
    padding: 0px 2px 0px 5px;
    font-size: 10px;
    box-sizing: border-box;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 14px;
    display: flex;
    align-items: center;
    .text {
      display: inline-flex;
      align-items: center;
      margin-left: 2px;
      background: #ffffff;
      border-radius: 2px;
      font-size: 8px;
      line-height: 11px;
      color: rgba(0, 0, 0, 0.8);
      padding: 0px 2px;
      .num {
        font-size: 10px;
        font-family: GothamMedium;
        margin-right: 2px;
      }
    }
  }
}

.user-info .camp {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.7);
  line-height: 17px;
  height: 17px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.camp .line {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.4);
}
.user-info .tag-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.user-info .tag-item {
  text-align: center;
  color: #000;
  font-size: 10px;
  height: 22px;
  padding: 0px 15px;
  box-sizing: border-box;
  white-space: nowrap;
  line-height: 22px;
  background: #f7f7f7;
  border-radius: 4px;
  margin-right: 6px;
  margin-top: 7px;
}

.user-info-right {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
}

.user-info .tag-list .tag-item:last-child {
  margin-right: 0px;
}
.compare-canvas {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.9) 0%,
    rgba(255, 255, 255, 0.7) 100%
  );
  border-radius: 12px;
  padding: 14px 20px;
  box-sizing: border-box;
  margin-bottom: 16px;
}
.compare-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  .text {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;
    .unit {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
    }
  }
}
.type-list {
  width: 82px;
  padding: 1px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 20px;
  background-color: #e8e8e8;
  border-radius: 4px;
  font-size: 10px;
}

.type-list .iconfont {
  margin-left: 5px;
}

.type-list .type-item {
  width: 40px;
  text-align: center;
  line-height: 20px;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.6);
}
.type-list .type-item-active {
  width: 40px;
  height: 18px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.8);
  background-color: #ffffff;
  border-radius: 4px;
}
.echart-canvas .no-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.my-swipe {
  height: 220px;
  .compare-swiper-item {
    display: flex;
    justify-content: center;
  }
}
.nav-list {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  background: #fff;
  border-radius: 12px 12px 0px 0px;
  .nav-item {
    flex: 1;
    text-align: center;
    position: relative;
    height: 100%;
    padding: 0px 10px;
    box-sizing: border-box;
    background: #f0f0f0;
    font-size: 14px;
    line-height: 38px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.5);
    .nav-flag {
      white-space: nowrap;
      padding: 0px 4px;
      border-radius: 4px;
      background: #6236ff;
      position: absolute;
      z-index: 1;
      top: -12px;
      right: 50%;
      font-size: 10px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      height: 18px;
      transform: translate(50%, 0%);
      line-height: 18px;
    }
    .nav-flag::after {
      content: '';
      z-index: -1;
      position: absolute;
      width: 0;
      height: 0;
      bottom: -2px;
      right: 10px;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 10px solid #6236ff;
      transform: rotate(90deg);
    }
  }
  .nav-item:first-child {
    border-top-left-radius: 12px;
  }
  .nav-item:last-child {
    border-top-right-radius: 12px;
  }
  .nav-item-before {
    border-bottom-right-radius: 8px;
  }
  .nav-item-after {
    border-bottom-left-radius: 8px;
  }
  .nav-item-active {
    height: 60px;
    line-height: 60px;
    background: #ffffff;
    border-radius: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
  }
}
.wapper {
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 12px;
}
.wapper-padding {
  padding: 0px 20px;
  box-sizing: border-box;
}
.wapper-1 {
  padding-top: 20px;
  padding-bottom: 20px;
  margin-bottom: 16px;
  .life-container {
    margin-bottom: 27px;
  }
  .compare-container {
    margin-bottom: 42px;
    .list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 18px;
      position: relative;
      .item {
        .image {
          width: 141px;
          height: 170px;
          border-radius: 10px;
          margin-bottom: 8px;
          object-fit: cover;
        }
        .text {
          text-align: center;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.8);
          line-height: 17px;
        }
      }
      .icon {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 52px;
        color: rgba(137, 104, 255, 0.5);
      }
    }
    .list:last-child {
      margin-bottom: 0px;
    }
  }
  .say-container {
    margin-bottom: 36px;
    .say-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .quotation-marks {
        width: 48px;
        height: 37px;
        object-fit: contain;
      }
      .center {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        text-align: right;
        margin-right: 12px;
        .nickname {
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 25px;
          margin-bottom: 2px;
        }
        .class {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.7);
          line-height: 17px;
        }
      }
      .user-avatar {
        width: 48px;
        height: 48px;
        border-radius: 16px;
        object-fit: cover;
      }
    }
    .say-list {
      margin-top: 16px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.8);
      line-height: 26px;
    }
  }
  .camp-screenshot {
    overflow: hidden;
    transform: translate3d(0, 0, 0);
    .screenshot-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      .title {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 25px;
      }
      .q-a {
        width: 120px;
        height: 50px;
      }
    }
    .desc {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
      line-height: 24px;
      margin-bottom: 27px;
    }
    .screenshot-swipe {
      width: 272px;
      height: 470px;
      margin: 0 auto;
      overflow: visible;
      .screenshot-item {
        width: 100%;
        height: 100%;
        padding: 0px 8px;
        box-sizing: border-box;
        .screenshot-image {
          margin: 0 auto;
          width: 256px;
          height: 100%;
          object-fit: cover;
          background: #efefef;
          border-radius: 20px;
        }
      }
    }
  }
}
.wapper-2 {
  padding: 20px;
  margin-bottom: 16px;
  .desc {
    margin-bottom: 20px;
  }
  .clock-info {
    text-align: center;
    display: flex;
    align-items: center;
    margin-bottom: 32px;
    .clock-item {
      flex: 1;
      .item-text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;
        margin-bottom: 10px;
      }
      .item-num {
        height: 24px;
        font-size: 24px;
        font-family: DINCondensed-Bold, DINCondensed;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.8);
        line-height: 20px;
      }
    }
  }
  .diet-container {
    min-height: 20px;
    position: relative;
    .diet-nav {
      position: absolute;
      top: 0px;
      right: 0px;
    }
    .day-content {
      margin-bottom: 32px;
      .day-top {
        margin-bottom: 16px;
        .day {
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 25px;
          margin-right: 10px;
        }
        .time {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 20px;
        }
      }
      .day-list {
        .diet-item {
          display: flex;
          align-items: stretch;
          .diet-left {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 10px;
            .left-dot {
              width: 16px;
              height: 16px;
              background: #ffffff;
              box-sizing: border-box;
              border: 3px solid #6236ff;
              border-radius: 50%;
            }
            .left-line {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;
              width: 1px;
              background-color: #f1f1f1;
            }
          }
          .diet-right {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            .right-top {
              margin-bottom: 8px;
              .type {
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.8);
                line-height: 22px;
                margin-right: 10px;
              }
              .pub-time {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.5);
                line-height: 20px;
              }
            }
            .user-text {
              font-size: 13px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.5);
              line-height: 22px;
              margin-bottom: 8px;
              white-space: pre-line;
              word-break: break-all;
            }
            .diet-image-list {
              margin-bottom: 10px;
              position: relative;
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              .diet-image {
                width: 125px;
                height: 125px;
                object-fit: cover;
                border-radius: 8px;
                margin: 5px 10px 5px 0px;
              }
              .diet-image-1 {
                width: 220px;
                height: 220px;
                border-radius: 8px;
              }
              .diet-image:nth-child(2n) {
                margin-right: 0px;
              }
              .image-num {
                position: absolute;
                right: 8px;
                bottom: 8px;
                padding: 0px 8px;
                height: 30px;
                line-height: 30px;
                background: rgba(0, 0, 0, 0.8);
                border-radius: 7px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #ffffff;
                line-height: 30px;
              }
            }
            .score {
              display: flex;
              align-items: center;
              margin-bottom: 32px;
              .num {
                margin-right: 8px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.8);
                line-height: 22px;
              }
              .star-list {
                .star {
                  margin-right: 2px;
                  color: #ddd;
                }
                .star-active {
                  color: #f7b500;
                }
              }
            }
          }
        }
        .diet-item:last-child {
          .score {
            margin-bottom: 0px;
          }
        }
      }
    }
    .day-content:last-child {
      margin-bottom: 0;
    }
    .not-diet {
      text-align: center;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.5);
      margin: 40px 0px;
    }
  }
}
.case-image-content {
  .case-image {
    width: 100%;
  }
}
.compare-swiper-content {
  width: 100%;
}
.compare-swiper {
  width: 100%;
  height: 100%;
}
.image-content {
  box-sizing: border-box;
  display: inline-flex;
  border-radius: 12px;
  overflow: hidden;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.image-content .line {
  border: 1px solid #e7e7e7;
  width: 0;
  height: 100%;
}
.image-item {
  width: 148px;
  height: 100%;
  box-sizing: border-box;
  background: #fff;
  border-radius: 1px;
  overflow: hidden;
  position: relative;
  .flag {
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    position: absolute;
    top: 0;
    width: 64px;
    height: 22px;
    line-height: 22px;
    text-align: center;
  }
  .time {
    position: absolute;
    bottom: 11px;
    font-size: 10px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 14px;
  }
}
.compare-swiper-content {
  .before {
    border-radius: 12px 0px 0px 12px;
    overflow: hidden;
    .flag {
      left: 0;
      background: #5c4378;
      border-radius: 6px 0px 6px 0px;
    }
    .time {
      left: 15px;
    }
  }
  .after {
    border-radius: 0px 12px 12px 0px;
    overflow: hidden;
    .flag {
      right: 0;
      background: linear-gradient(8deg, #f44aff 0%, #6236ff 100%);
      border-radius: 0px 8px 0px 8px;
    }
    .time {
      right: 15px;
    }
  }
}
.image-text {
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000;
  line-height: 17px;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}
.footer-content {
  position: fixed;
  width: 100%;
  padding: 11px 15px 17px;
  z-index: 6;
  padding-bottom: calc(
    17px + 0.5 * constant(safe-area-inset-bottom)
  ); //兼容 IOS<11.2
  padding-bottom: calc(
    17px + 0.5 * env(safe-area-inset-bottom)
  ); //兼容 IOS>11.2
  left: 0;
  bottom: 0;
  background-color: #fff;
  box-sizing: border-box;
  border-top: 1px solid #f8f8f8;
  .footer-top {
    display: flex;
    align-items: flex-end;
    .avatar {
      width: 40px;
      height: 40px;
      margin-right: 11px;
      border-radius: 10px;
    }
    .center {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      margin-right: 10px;
      .name {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 20px;
      }
      .desc {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.4);
        line-height: 17px;
      }
    }
    .btn-content {
      text-align: center;
      position: relative;
      width: 89px;
      height: 28px;
      background: #6236ff;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 17px;
      .iconfont {
        font-size: 14px;
        margin-right: 6px;
        color: #fff;
      }
      .free {
        position: absolute;
        top: -14px;
        padding: 0px 8px;
        right: -6px;
        height: 20px;
        background: #e54172;
        border-radius: 4px;
        line-height: 20px;
        font-size: 10px;
        font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
        color: #ffffff;
      }
    }
  }
  .footer-bottom {
    margin-top: 10px;
    background: #f1f1f1;
    padding: 5px 17px;
    border-radius: 9px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    line-height: 17px;
    .gray {
      color: rgba(0, 0, 0, 0.3);
    }
  }
}
.comment-list {
  background-color: #fff;
  padding: 10px 20px;
}
/*  */
.echart-swiper {
  width: 100%;
  height: 100%;
}
.compare-image-content {
  width: 100%;
  height: 100%;
}
.compare-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.v-loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.mychart-content {
  height: 150px;
}
.mychart-content .my-chart {
  width: 100%;
  height: 100%;
}
.compare-weight {
  display: flex;
  align-items: center;
  justify-content: space-around;
  .item {
    text-align: center;
  }
  .item-title {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.5);
    line-height: 17px;
    margin-bottom: 10px;
  }
  .item-unit {
    font-size: 10px;
    margin-left: 4px;
  }
  .item-text {
    height: 24px;
    font-size: 24px;
    font-family: DINCondensed-Bold, DINCondensed;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    display: flex;
    align-items: center;
    .iconfont {
      color: #6236ff;
      font-size: 11px;
    }
    .up {
      width: 20px;
      height: 20px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      transform: rotate(180deg);
    }
    .down {
    }
  }
  .blue {
    color: #6236ff;
  }
}
.swiper-indicator {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}
.swiper-indicator .swiper-indicator-item {
  width: 4px;
  height: 4px;
  background: rgba(0, 0, 0, 0.24);
  border-radius: 2px;
  margin-right: 3px;
}
.swiper-indicator .swiper-indicator-item-active {
  width: 16px;
  height: 4px;
  background: #6236ff;
  border-radius: 2px;
}
.not-more {
  font-size: 14px;
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
  margin: 10px 0px;
}
.similar-case {
  padding: 20px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 27px;
  .title {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 25px;
    margin-bottom: 17px;
  }
  .case-list {
    .case-item {
      display: flex;
      align-items: center;
      margin-bottom: 21px;
      .avatar {
        width: 44px;
        height: 44px;
        background: #d8d8d8;
        border-radius: 10px;
        margin-right: 9px;
        object-fit: cover;
      }
      .item-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        .nickname {
          font-size: 14px;
          height: 20px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          line-height: 20px;
        }
        .desc {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.3);
          line-height: 17px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
      .iconfont {
        margin-left: 10px;
        color: #999;
      }
    }
    .case-item:last-child {
      margin-bottom: 0;
    }
  }
}
.share-container {
  position: absolute;
  left: 0;
  bottom: 0;
}
.n-info {
  padding: 16px 20px 12px;
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 26px;
  .c-top {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .avatar {
      width: 36px;
      height: 36px;
      border-radius: 6px;
      overflow: hidden;
      margin-right: 10px;
      object-fit: cover;
    }
    .name {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      margin-right: 10px;
      .c-name {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.8);
        line-height: 14px;
      }
      .nickname {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 20px;
      }
    }
    .iconfont {
      color: #666666;
    }
  }
  .desc {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    background: #f7f7f7;
    border-radius: 2px;
    padding: 3px 13px;
    font-size: 10px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.5);
    line-height: 14px;
    margin-bottom: 10px;
  }
  .bottom {
    display: flex;
    align-items: flex-start;
    text-align: center;
    .b-item {
      position: relative;
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      .b-title {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.8);
        line-height: 14px;
        margin-bottom: 8px;
      }
      .num {
        height: 20px;
        font-size: 20px;
        font-family: DINCondensed-Bold, DINCondensed;
        font-weight: bold;
        vertical-align: text-top;
        color: rgba(0, 0, 0, 0.8);
        line-height: 20px;
      }
      .star-content {
        height: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(247, 181, 0, 1);
        .star {
          font-size: 13px;
        }
      }
    }
    .b-item::after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translate(0%, -50%);
      width: 1px;
      height: 26px;
      background-color: #f1f1f1;
    }
    .b-item:last-child::after {
      display: none;
    }
  }
}
</style>
